import { useContext, useMemo } from 'react'
import range from 'lodash/range'
import { CutterContext } from '../../contexts/CutterContext'

export function useChannels() {
  const { numberOfChannels } = useContext(CutterContext).audio

  return useMemo(() => range(numberOfChannels), [numberOfChannels])
}
